import { SoStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class DomesticSalesDto{
    @ApiProperty()
    id: number;
    @ApiProperty()
    domesticSaleOrderNo: string;
    @ApiProperty()
    customer:number;
    @ApiProperty()
    varient: number;
    @ApiProperty()
    packStyleId: number;
    @ApiProperty()
    quantity: number;
    @ApiProperty()
    location: number;
    @ApiProperty()
    stockId: number;
    @ApiProperty()
    unitPrice: number;
    @ApiProperty()
    taxId: number;
    @ApiProperty()
    amount: number;
    @ApiProperty()
    cases: number;
    @ApiProperty()
    loosePouches: number;
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    saleOrderDate: Date;
    @ApiProperty()
    isActive?: boolean;
    @ApiProperty()
    createdUser?: string | null;
    @ApiProperty()
    updatedUser?: string | null;
    @ApiProperty()
    stockqnty?:number;
}